import { useEffect } from "react";
import { useLocation } from "react-router-dom";
function useScrollToTop() {
  var location = useLocation();
  useEffect(function () {
    window.scrollTo(0, 0);
    document.body.style.overflow = "";
  }, [location]);
}
export default useScrollToTop;